// const path = require('path');
// const fs = require('fs-extra');
const extend = require('extend');
const Q = require('q');
const _ = require('underscore');
// const moment = require('moment');
// const qs = require(`qs`);
const axios = require(`axios`);

const __get_token__ = require(`../../../../lib/common-service/yinzhilv/get_token`);
const get_url_prefix = require(`../../../../lib/common-service/get_url_prefix`);
const __redirect_to_login_page = require(`../../../../lib/common-service/yinzhilv/redirect_to_login_page`).default;
const __alert = require(`../../../../lib/common-service/yinzhilv/alert`).default;

const __request_contentType_json = function (pParameter) {
    const defaultParameter = {};
    defaultParameter.environment = ``;
    defaultParameter.get_token = null;
    defaultParameter.method = `post`;
    defaultParameter.appKey = `default`;
    defaultParameter.urlSuffix = ``;
    defaultParameter.data = {};
    defaultParameter.headers = {};
    defaultParameter.redirect_to_login_page = null;
    defaultParameter.alert = null;
    defaultParameter.check_token = true;
    defaultParameter.process_response_data = true;
    defaultParameter.enable_error_alert = true;

    const parameter = extend(true, {}, defaultParameter, pParameter);

    const __environment = parameter.environment;
    const __get_token = parameter.get_token;
    const method = parameter.method;
    const appKey = parameter.appKey;
    const urlSuffix = parameter.urlSuffix;
    const data = parameter.data;
    const headers = parameter.headers;
    const check_token = parameter.check_token;
    const process_response_data = parameter.process_response_data;
    const enable_error_alert = parameter.enable_error_alert;

    let redirect_to_login_page;
    if (_.isFunction(parameter.redirect_to_login_page)) {
        redirect_to_login_page = parameter.redirect_to_login_page;
    } else {
        redirect_to_login_page = __redirect_to_login_page;
    }

    let __alert__;
    if (_.isFunction(parameter.alert)) {
        __alert__ = parameter.alert;
    } else {
        __alert__ = __alert;
    }

    if (!global.appConfig) {
        const msg = '__request_contentType_json parameter error, code=001';
        console.error(msg);
        return Q.reject({msg: msg});
    }

    const environment = __environment || global.appConfig.environment;
    if (!environment) {
        const msg = '__request_contentType_json parameter error, code=002';
        console.error(msg);
        return Q.reject({msg: msg});
    }

    let get_token;
    if (_.isFunction(__get_token)) {
        get_token = __get_token;
    } else {
        get_token = __get_token__;
    }

    let token = ``;
    if (check_token) {
        token = get_token();
    }

    const urlPrefix = get_url_prefix({
        environment: environment,
        appKey: appKey,
    });

    const options = {
        method: method,
        baseURL: urlPrefix,
        url: urlSuffix,
        data: data,
        headers: headers,

        // proxy: {
        //   host: '127.0.0.1',
        //   port: 8888,
        // },
    };

    if (check_token) {
        options.headers[`Token`] = token;
    }

    let r = Q.when()
        .then(function () {
            return axios(options);
        })
        .then(function (r) {
            const data = r.data;
            return Q.resolve(data);
        })
    ;

    if (process_response_data) {
        r = r.then(function (data) {
            if (!data) {
                const msg = '__request_contentType_json parameter error, code=100';
                console.error(msg);
                return Q.reject({msg: msg});
            }

            const __msg = data.msg;

            const code = data.code;
            if (!code) {
                const msg = '__request_contentType_json parameter error, code=101';
                console.error(msg);
                return Q.reject({msg: msg});
            }

            if (code === `000000`) {
                return data;
            }

            //USER_TOKEN_NOT_EXIST("002001", "token不存在"),
            if (code === `002001`) {
                console.error(__msg);
                __alert__(`登录超时，请重新登录！code=${code}`);
                redirect_to_login_page();
                return Q.reject({msg: __msg});
            }

            //USER_TOKEN_LEGAL("002002", "不合法的token或token过期"),
            if (code === `002002`) {
                console.error(__msg);
                __alert__(`登录超时，请重新登录！code=${code}`);
                redirect_to_login_page();
                return Q.reject({msg: __msg});
            }

            //USER_REPETITION_LOGIN("002008", "您已经在其他地方登录，请重新登录！"),
            if (code === `002008`) {
                console.error(__msg);
                __alert__(__msg);
                redirect_to_login_page();
                return Q.reject({msg: __msg});
            }

            //USER_NOT_LOGIN("002010", "该用户还没登录"),
            if (code === `002010`) {
                console.error(__msg);
                __alert__(`登录超时，请重新登录！code=${code}`);
                redirect_to_login_page();
                return Q.reject({msg: __msg});
            }

            const msg = `__request_contentType_json parameter error, code=${code}`;
            console.error(msg);
            if (enable_error_alert) alert(__msg);
            return Q.reject({
                msg: msg,
                data: data,
            });

        });
    }

    r = r.catch(function (ex) {
        console.error(ex);
        if (ex) {
            if (ex.stack) {
                console.error(ex.stack);
            }
        }
        return Q.reject(ex);
    })
    ;

    return r;
};

module.exports = __request_contentType_json;
